export const fullname = (person: Person | User | { [key: string]: string | number | boolean }): string => {
  return `${person.firstName} ${person.lastName}`
}

export const connectorName = (connector: Connector) => {
  if (connector.isAnonymous) return 'Anonymous'
  return `${connector.firstName} ${connector.lastName}`
}
